import { LogIn, AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth-store';

export function SessionExpiredModal() {
  const navigate = useNavigate();
  const sessionExpired = useAuthStore((s) => s.sessionExpired);
  const logout = useAuthStore((s) => s.logout);

  if (!sessionExpired) return null;

  const handleLogin = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[9999] flex items-center justify-center p-4">
      <div className="bg-white rounded-[24px] w-full max-w-sm shadow-ios-xl animate-in fade-in zoom-in duration-200">
        <div className="p-8 text-center">
          <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-5">
            <LogIn size={36} className="text-ios-red" />
          </div>
          <h2 className="text-xl font-bold mb-2">Sesión expirada</h2>
          <p className="text-sm text-ios-gray mb-6 leading-relaxed">
            Tu sesión ha expirado por inactividad. 
            Inicia sesión nuevamente para continuar trabajando.
          </p>
          <button
            onClick={handleLogin}
            className="w-full ios-button ios-button-destructive inline-flex items-center justify-center gap-2 py-3"
          >
            <LogIn size={18} />
            Iniciar sesión
          </button>
        </div>
      </div>
    </div>
  );
}
